<template>
    <v-data-table
            class="data-table"
            :items="applicants"
            :headers="headers"
            fixed-header
            height="700"
            :items-per-page="itemsPerPage"
            :loading="isLoading"
            :search="search"
            @click:row="goToApplicant"
            loading-text="Awaiting data...">
    </v-data-table>
</template>

<script>
    import { mapActions } from 'vuex'
    export default {
        name: "ApplicantsTable",
        methods: {
          ...mapActions(['setApplicantEmail']),
          goToApplicant(applicant) {
              this.setApplicantEmail(applicant)
              this.$router.push(`/profile/${applicant.id}`)

          },
        },
        props: {
            applicants: Array,
            isLoading: Boolean,
            search: String,
            itemsPerPage: Number,
            headers: Array,
        },
    }
</script>

<style scoped>
    .data-table {
        border-top-right-radius: 0;
        cursor: pointer;
    }
</style>